import ErrorView from "../Error";
import { AuthCode } from "@hooks/useApi";

type AuthErrorProps = {
	error?: (Error & { cause?: { status?: number; code?: string } }) | null;
};

// BANNED state is handled by the Banned component in AuthContext
const DESCRIPTIONS: Record<string, string> = {
	[AuthCode.UNREGISTERED]:
		"We couldn't automatically register your account.",
	[AuthCode.REQUIRES_SYNC]:
		"We couldn't automatically synchronise your account.",
	[AuthCode.AUTHENTICATION_FAILED]:
		"Authentication failed. Please log in again.",
};

function AuthError({ error }: AuthErrorProps) {
	const { status, code } = error?.cause || {};
	const isServerBug =
		code === AuthCode.AUTHENTICATION_FAILED && status === 501;
	const description = isServerBug
		? "Authentication failed because of a server error. This is a bug — please report it to support."
		: (code && DESCRIPTIONS[code]) ||
			(error
				? "Something went wrong while signing you in."
				: "Please log in to access the portal.");

	return (
		<ErrorView>
			<p>{description}</p>
			{error && (
				<p className="text-sm" data-testid="auth-error-details">
					{[status, code || error.message].filter(Boolean).join(": ")}
				</p>
			)}
			{(isServerBug || !code) && error && (
				<p className="text-sm">
					Please include this message when contacting{" "}
					<a href="mailto:dnks@warrisk.no">support</a>.
				</p>
			)}
		</ErrorView>
	);
}

export default AuthError;
